import React from 'react';
import { ChakraProvider, theme } from '@chakra-ui/react';

import Routing from './Routes/Routing';
import { Wrapper } from './Global.style';
import 'bootstrap/dist/css/bootstrap.css';
function App() {
  return (
    <ChakraProvider theme={theme}>
      <Wrapper>
        <Routing />
      </Wrapper>
    </ChakraProvider>
  );
}

export default App;
